"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NativeInput = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var field_1 = require("./field");

var field = ui_blocks_1.FORM.field;
exports.NativeInput = styled_components_1.default.input(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", "\n  appearance: none;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  padding: 0 1rem;\n\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  appearance: none;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  padding: 0 1rem;\n\n  ", "\n  ", "\n  ", "\n"])), field, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'sizeOption', field_1.makeSizeStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'hasErrors', field_1.hasErrorsStyles);
}, function (_a) {
  var isInline = _a.isInline;
  return isInline && field_1.inlineStyles;
});
var templateObject_1;